import React, { Component } from "react";
import Desplegable from "../../desplegable";
import VistaDatosCanonicos from "../vistas/vista_datos_canonicos";
import FormDatosCanonicos from "../formularios/form_datos_canonicos";

export default class DesplegableDatosCanonicos extends Component {
  render() {
    return (
      <Desplegable
        eventKey="0"
        id="0"
        Toogle="Datos Canónicos"
        handleButtonShow={this.props.handleButtonShow}
        showModal={this.props.state.showModalArray[0]}
        Text={<VistaDatosCanonicos DatosProvincia={this.props.state.DatosProvincia}></VistaDatosCanonicos>}
        Form={
          <FormDatosCanonicos
            DatosProvincia={this.props.state.DatosProvincia}
            setInformacionOrganismo={this.props.setInformacionOrganismo}
            handleButtonShow={this.props.handleButtonShow}
            nullField={this.props.nullField}
            setAlert={this.props.setAlert}
            ErrorHandling={this.props.ErrorHandling}
          ></FormDatosCanonicos>
        }
        canEdit={true}
      />
    );
  }
}
